const ALLOWED_ROUTES = process.env.VUE_APP_PODY_ALLOWED_ROUTES?.split(',') ?? []

// Create a route for each allowed path
const routes = ALLOWED_ROUTES.map(route => ({
  path: `/${route}`,
  name: `${route.replace(/\//g, '-')}`,
  component: () => import('@/views/pody/PodyFrame.vue'),
  meta: {
    pageTitle: 'Creative center',
    requireAuth: true,
    breadcrumb: [
      {
        text: 'Creative center',
        active: true,
      },
    ],
    layout: 'vertical',
  },
}))

export default routes
